import { render, staticRenderFns } from "./base_new.vue?vue&type=template&id=b1f2907e&scoped=true&"
import script from "./base_new.vue?vue&type=script&lang=js&"
export * from "./base_new.vue?vue&type=script&lang=js&"
import style0 from "./base_new.vue?vue&type=style&index=0&id=b1f2907e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1f2907e",
  null
  
)

export default component.exports